import React from 'react'
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import { Field } from 'formik'

export default function FormikCheckboxField(props) {
  return (
    <InputGroup sm="auto">
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <Input
            addon
            aria-label={props.label}
            checked={props.isChecked}
            id={props.name}
            name={props.name}
            tag={Field}
            type="checkbox"
          />
        </InputGroupText>
      </InputGroupAddon>
      <Input disabled placeholder={props.label} />
    </InputGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/FormikCheckboxField.js